export default __webpack_public_path__ + "static/media/noa-49.ef560686.jpg";